// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,json_types=true"
// @generated from file compliance/v1/compliance.proto (package compliance.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_common_v1_annotations } from "../../common/v1/annotations_pb";
import type { PaginationArguments, PaginationArgumentsJson, PaginationPageInfo, PaginationPageInfoJson } from "../../common/v1/pagination_pb";
import { file_common_v1_pagination } from "../../common/v1/pagination_pb";
import type { Creator, CreatorJson } from "../../common/v1/types_pb";
import { file_common_v1_types } from "../../common/v1/types_pb";
import type { Timestamp, TimestampJson, Value, ValueJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Status, StatusJson } from "../../google/rpc/status_pb";
import { file_google_rpc_status } from "../../google/rpc/status_pb";
import type { Notification, NotificationJson } from "../../notifications/v2/notifications_pb";
import { file_notifications_v2_notifications } from "../../notifications/v2/notifications_pb";
import type { PurgeOrganizationData, PurgeOrganizationDataJson, PurgeUserData, PurgeUserDataJson } from "../../system/v1/events_pb";
import { file_system_v1_events } from "../../system/v1/events_pb";
import type { MappedValue, MappedValueJson } from "../../workflows/v1/workflows_pb";
import { file_workflows_v1_workflows } from "../../workflows/v1/workflows_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file compliance/v1/compliance.proto.
 */
export const file_compliance_v1_compliance: GenFile =
	/*@__PURE__*/
	fileDesc(
		"Ch5jb21wbGlhbmNlL3YxL2NvbXBsaWFuY2UucHJvdG8SDWNvbXBsaWFuY2UudjEiiQIKCVB1cmdlU3RlcBIKCgJpZBgBIAEoCRIOCgZqb2JfaWQYAiABKAkSEAoIcHVyZ2VfaWQYAyABKAkSEQoJc291cmNlX2lkGAQgASgJEg4KBm9yZ19pZBgFIAEoCRIuCgZzdGF0dXMYBiABKA4yHi5jb21wbGlhbmNlLnYxLlB1cmdlU3RlcFN0YXR1cxIhCgVlcnJvchgHIAEoCzISLmdvb2dsZS5ycGMuU3RhdHVzEigKCG1ldGFkYXRhGAggASgLMhYuZ29vZ2xlLnByb3RvYnVmLlZhbHVlEi4KCmNyZWF0ZWRfYXQYCSABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wIsQCCgNKb2ISCgoCaWQYASABKAkSDgoGb3JnX2lkGAIgASgJEiMKB2NyZWF0b3IYAyABKAsyEi5jb21tb24udjEuQ3JlYXRvchIRCgljb21wbGV0ZWQYBCABKAgSDAoEc2l6ZRgFIAEoBRIUCgxzb3VyY2VfY291bnQYBiABKAUSGAoQdG90YWxfc3RlcF9jb3VudBgHIAEoBRIVCg1zdWNjZXNzX2NvdW50GAggASgFEhMKC2Vycm9yX2NvdW50GAkgASgFEhEKCWZpbGVfbmFtZRgMIAEoCRI8ChRzdW1tYXJ5X25vdGlmaWNhdGlvbhgKIAEoCzIeLm5vdGlmaWNhdGlvbnMudjIuTm90aWZpY2F0aW9uEi4KCmNyZWF0ZWRfYXQYCyABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wIpcBChBQdXJnZURhdGFSZXF1ZXN0EjMKD3B1cmdlX3VzZXJfZGF0YRgBIAEoCzIYLnN5c3RlbS52MS5QdXJnZVVzZXJEYXRhSAASQwoXcHVyZ2Vfb3JnYW5pemF0aW9uX2RhdGEYAiABKAsyIC5zeXN0ZW0udjEuUHVyZ2VPcmdhbml6YXRpb25EYXRhSABCCQoHcmVxdWVzdCITChFQdXJnZURhdGFSZXNwb25zZSKLAgoUQnVsa1B1cmdlRGF0YVJlcXVlc3QSDgoGb3JnX2lkGAEgASgJEhAKCGZpbGVfdXJsGAIgASgJEhEKCWZpbGVfbmFtZRgHIAEoCRIMCgRzaXplGAYgASgFEkEKB21hcHBpbmcYAyADKAsyMC5jb21wbGlhbmNlLnYxLkJ1bGtQdXJnZURhdGFSZXF1ZXN0Lk1hcHBpbmdFbnRyeRISCgpoYXNfaGVhZGVyGAQgASgIEg4KBmhlYWRlchgFIAMoCRpJCgxNYXBwaW5nRW50cnkSCwoDa2V5GAEgASgJEigKBXZhbHVlGAIgASgLMhkud29ya2Zsb3dzLnYxLk1hcHBlZFZhbHVlOgI4ASIXChVCdWxrUHVyZ2VEYXRhUmVzcG9uc2UiVQoPTGlzdEpvYnNSZXF1ZXN0Eg4KBm9yZ19pZBgBIAEoCRIyCgpwYWdpbmF0aW9uGAIgASgLMh4uY29tbW9uLnYxLlBhZ2luYXRpb25Bcmd1bWVudHMiZgoQTGlzdEpvYnNSZXNwb25zZRIgCgRqb2JzGAEgAygLMhIuY29tcGxpYW5jZS52MS5Kb2ISMAoJcGFnZV9pbmZvGAIgASgLMh0uY29tbW9uLnYxLlBhZ2luYXRpb25QYWdlSW5mbyKLAQoVTGlzdFB1cmdlU3RlcHNSZXF1ZXN0Eg4KBmpvYl9pZBgBIAEoCRIuCgZzdGF0dXMYAiABKA4yHi5jb21wbGlhbmNlLnYxLlB1cmdlU3RlcFN0YXR1cxIyCgpwYWdpbmF0aW9uGAMgASgLMh4uY29tbW9uLnYxLlBhZ2luYXRpb25Bcmd1bWVudHMieQoWTGlzdFB1cmdlU3RlcHNSZXNwb25zZRItCgtwdXJnZV9zdGVwcxgBIAMoCzIYLmNvbXBsaWFuY2UudjEuUHVyZ2VTdGVwEjAKCXBhZ2VfaW5mbxgCIAEoCzIdLmNvbW1vbi52MS5QYWdpbmF0aW9uUGFnZUluZm8ihwEKEUxpc3RQdXJnZXNSZXF1ZXN0Eg4KBmpvYl9pZBgBIAEoCRIuCgZzdGF0dXMYAiABKA4yHi5jb21wbGlhbmNlLnYxLlB1cmdlU3RlcFN0YXR1cxIyCgpwYWdpbmF0aW9uGAMgASgLMh4uY29tbW9uLnYxLlBhZ2luYXRpb25Bcmd1bWVudHMidQoSTGlzdFB1cmdlc1Jlc3BvbnNlEi0KC3B1cmdlX3N0ZXBzGAEgAygLMhguY29tcGxpYW5jZS52MS5QdXJnZVN0ZXASMAoJcGFnZV9pbmZvGAIgASgLMh0uY29tbW9uLnYxLlBhZ2luYXRpb25QYWdlSW5mbypyCg9QdXJnZVN0ZXBTdGF0dXMSIQodUFVSR0VfU1RFUF9TVEFUVVNfVU5TUEVDSUZJRUQQABIdChlQVVJHRV9TVEVQX1NUQVRVU19TVUNDRVNTEAESHQoZUFVSR0VfU1RFUF9TVEFUVVNfRkFJTFVSRRACMuYDChFDb21wbGlhbmNlU2VydmljZRJWCglQdXJnZURhdGESHy5jb21wbGlhbmNlLnYxLlB1cmdlRGF0YVJlcXVlc3QaIC5jb21wbGlhbmNlLnYxLlB1cmdlRGF0YVJlc3BvbnNlIgbC7RoCCAISYgoNQnVsa1B1cmdlRGF0YRIjLmNvbXBsaWFuY2UudjEuQnVsa1B1cmdlRGF0YVJlcXVlc3QaJC5jb21wbGlhbmNlLnYxLkJ1bGtQdXJnZURhdGFSZXNwb25zZSIGwu0aAggCElMKCExpc3RKb2JzEh4uY29tcGxpYW5jZS52MS5MaXN0Sm9ic1JlcXVlc3QaHy5jb21wbGlhbmNlLnYxLkxpc3RKb2JzUmVzcG9uc2UiBsLtGgIIAhJlCg5MaXN0UHVyZ2VTdGVwcxIkLmNvbXBsaWFuY2UudjEuTGlzdFB1cmdlU3RlcHNSZXF1ZXN0GiUuY29tcGxpYW5jZS52MS5MaXN0UHVyZ2VTdGVwc1Jlc3BvbnNlIgbC7RoCCAISWQoKTGlzdFB1cmdlcxIgLmNvbXBsaWFuY2UudjEuTGlzdFB1cmdlc1JlcXVlc3QaIS5jb21wbGlhbmNlLnYxLkxpc3RQdXJnZXNSZXNwb25zZSIGwu0aAggCYgZwcm90bzM",
		[file_common_v1_annotations, file_common_v1_pagination, file_common_v1_types, file_google_protobuf_struct, file_google_protobuf_timestamp, file_google_rpc_status, file_notifications_v2_notifications, file_system_v1_events, file_workflows_v1_workflows],
	);

/**
 * @generated from message compliance.v1.PurgeStep
 */
export type PurgeStep = Message<"compliance.v1.PurgeStep"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string job_id = 2;
	 */
	jobId: string;

	/**
	 * @generated from field: string purge_id = 3;
	 */
	purgeId: string;

	/**
	 * @generated from field: string source_id = 4;
	 */
	sourceId: string;

	/**
	 * @generated from field: string org_id = 5;
	 */
	orgId: string;

	/**
	 * @generated from field: compliance.v1.PurgeStepStatus status = 6;
	 */
	status: PurgeStepStatus;

	/**
	 * @generated from field: google.rpc.Status error = 7;
	 */
	error?: Status | undefined;

	/**
	 * @generated from field: google.protobuf.Value metadata = 8;
	 */
	metadata?: Value | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 9;
	 */
	createdAt?: Timestamp | undefined;
};

/**
 * @generated from message compliance.v1.PurgeStep
 */
export type PurgeStepJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string job_id = 2;
	 */
	jobId?: string;

	/**
	 * @generated from field: string purge_id = 3;
	 */
	purgeId?: string;

	/**
	 * @generated from field: string source_id = 4;
	 */
	sourceId?: string;

	/**
	 * @generated from field: string org_id = 5;
	 */
	orgId?: string;

	/**
	 * @generated from field: compliance.v1.PurgeStepStatus status = 6;
	 */
	status?: PurgeStepStatusJson;

	/**
	 * @generated from field: google.rpc.Status error = 7;
	 */
	error?: StatusJson;

	/**
	 * @generated from field: google.protobuf.Value metadata = 8;
	 */
	metadata?: ValueJson;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 9;
	 */
	createdAt?: TimestampJson;
};

/**
 * Describes the message compliance.v1.PurgeStep.
 * Use `create(PurgeStepSchema)` to create a new message.
 */
export const PurgeStepSchema: GenMessage<PurgeStep, { jsonType: PurgeStepJson }> = /*@__PURE__*/ messageDesc(file_compliance_v1_compliance, 0);

/**
 * @generated from message compliance.v1.Job
 */
export type Job = Message<"compliance.v1.Job"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId: string;

	/**
	 * @generated from field: common.v1.Creator creator = 3;
	 */
	creator?: Creator | undefined;

	/**
	 * @generated from field: bool completed = 4;
	 */
	completed: boolean;

	/**
	 * @generated from field: int32 size = 5;
	 */
	size: number;

	/**
	 * @generated from field: int32 source_count = 6;
	 */
	sourceCount: number;

	/**
	 * @generated from field: int32 total_step_count = 7;
	 */
	totalStepCount: number;

	/**
	 * @generated from field: int32 success_count = 8;
	 */
	successCount: number;

	/**
	 * @generated from field: int32 error_count = 9;
	 */
	errorCount: number;

	/**
	 * @generated from field: string file_name = 12;
	 */
	fileName: string;

	/**
	 * @generated from field: notifications.v2.Notification summary_notification = 10;
	 */
	summaryNotification?: Notification | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 11;
	 */
	createdAt?: Timestamp | undefined;
};

/**
 * @generated from message compliance.v1.Job
 */
export type JobJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string org_id = 2;
	 */
	orgId?: string;

	/**
	 * @generated from field: common.v1.Creator creator = 3;
	 */
	creator?: CreatorJson;

	/**
	 * @generated from field: bool completed = 4;
	 */
	completed?: boolean;

	/**
	 * @generated from field: int32 size = 5;
	 */
	size?: number;

	/**
	 * @generated from field: int32 source_count = 6;
	 */
	sourceCount?: number;

	/**
	 * @generated from field: int32 total_step_count = 7;
	 */
	totalStepCount?: number;

	/**
	 * @generated from field: int32 success_count = 8;
	 */
	successCount?: number;

	/**
	 * @generated from field: int32 error_count = 9;
	 */
	errorCount?: number;

	/**
	 * @generated from field: string file_name = 12;
	 */
	fileName?: string;

	/**
	 * @generated from field: notifications.v2.Notification summary_notification = 10;
	 */
	summaryNotification?: NotificationJson;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 11;
	 */
	createdAt?: TimestampJson;
};

/**
 * Describes the message compliance.v1.Job.
 * Use `create(JobSchema)` to create a new message.
 */
export const JobSchema: GenMessage<Job, { jsonType: JobJson }> = /*@__PURE__*/ messageDesc(file_compliance_v1_compliance, 1);

/**
 * @generated from message compliance.v1.PurgeDataRequest
 */
export type PurgeDataRequest = Message<"compliance.v1.PurgeDataRequest"> & {
	/**
	 * @generated from oneof compliance.v1.PurgeDataRequest.request
	 */
	request:
		| {
				/**
				 * @generated from field: system.v1.PurgeUserData purge_user_data = 1;
				 */
				value: PurgeUserData;
				case: "purgeUserData";
		  }
		| {
				/**
				 * @generated from field: system.v1.PurgeOrganizationData purge_organization_data = 2;
				 */
				value: PurgeOrganizationData;
				case: "purgeOrganizationData";
		  }
		| { case: undefined; value?: undefined };
};

/**
 * @generated from message compliance.v1.PurgeDataRequest
 */
export type PurgeDataRequestJson = {
	/**
	 * @generated from field: system.v1.PurgeUserData purge_user_data = 1;
	 */
	purgeUserData?: PurgeUserDataJson;

	/**
	 * @generated from field: system.v1.PurgeOrganizationData purge_organization_data = 2;
	 */
	purgeOrganizationData?: PurgeOrganizationDataJson;
};

/**
 * Describes the message compliance.v1.PurgeDataRequest.
 * Use `create(PurgeDataRequestSchema)` to create a new message.
 */
export const PurgeDataRequestSchema: GenMessage<PurgeDataRequest, { jsonType: PurgeDataRequestJson }> = /*@__PURE__*/ messageDesc(file_compliance_v1_compliance, 2);

/**
 * @generated from message compliance.v1.PurgeDataResponse
 */
export type PurgeDataResponse = Message<"compliance.v1.PurgeDataResponse"> & {};

/**
 * @generated from message compliance.v1.PurgeDataResponse
 */
export type PurgeDataResponseJson = {};

/**
 * Describes the message compliance.v1.PurgeDataResponse.
 * Use `create(PurgeDataResponseSchema)` to create a new message.
 */
export const PurgeDataResponseSchema: GenMessage<PurgeDataResponse, { jsonType: PurgeDataResponseJson }> = /*@__PURE__*/ messageDesc(file_compliance_v1_compliance, 3);

/**
 * @generated from message compliance.v1.BulkPurgeDataRequest
 */
export type BulkPurgeDataRequest = Message<"compliance.v1.BulkPurgeDataRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string file_url = 2;
	 */
	fileUrl: string;

	/**
	 * @generated from field: string file_name = 7;
	 */
	fileName: string;

	/**
	 * @generated from field: int32 size = 6;
	 */
	size: number;

	/**
	 * @generated from field: map<string, workflows.v1.MappedValue> mapping = 3;
	 */
	mapping: { [key: string]: MappedValue };

	/**
	 * @generated from field: bool has_header = 4;
	 */
	hasHeader: boolean;

	/**
	 * @generated from field: repeated string header = 5;
	 */
	header: string[];
};

/**
 * @generated from message compliance.v1.BulkPurgeDataRequest
 */
export type BulkPurgeDataRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string file_url = 2;
	 */
	fileUrl?: string;

	/**
	 * @generated from field: string file_name = 7;
	 */
	fileName?: string;

	/**
	 * @generated from field: int32 size = 6;
	 */
	size?: number;

	/**
	 * @generated from field: map<string, workflows.v1.MappedValue> mapping = 3;
	 */
	mapping?: { [key: string]: MappedValueJson };

	/**
	 * @generated from field: bool has_header = 4;
	 */
	hasHeader?: boolean;

	/**
	 * @generated from field: repeated string header = 5;
	 */
	header?: string[];
};

/**
 * Describes the message compliance.v1.BulkPurgeDataRequest.
 * Use `create(BulkPurgeDataRequestSchema)` to create a new message.
 */
export const BulkPurgeDataRequestSchema: GenMessage<BulkPurgeDataRequest, { jsonType: BulkPurgeDataRequestJson }> = /*@__PURE__*/ messageDesc(file_compliance_v1_compliance, 4);

/**
 * @generated from message compliance.v1.BulkPurgeDataResponse
 */
export type BulkPurgeDataResponse = Message<"compliance.v1.BulkPurgeDataResponse"> & {};

/**
 * @generated from message compliance.v1.BulkPurgeDataResponse
 */
export type BulkPurgeDataResponseJson = {};

/**
 * Describes the message compliance.v1.BulkPurgeDataResponse.
 * Use `create(BulkPurgeDataResponseSchema)` to create a new message.
 */
export const BulkPurgeDataResponseSchema: GenMessage<BulkPurgeDataResponse, { jsonType: BulkPurgeDataResponseJson }> = /*@__PURE__*/ messageDesc(file_compliance_v1_compliance, 5);

/**
 * @generated from message compliance.v1.ListJobsRequest
 */
export type ListJobsRequest = Message<"compliance.v1.ListJobsRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 2;
	 */
	pagination?: PaginationArguments | undefined;
};

/**
 * @generated from message compliance.v1.ListJobsRequest
 */
export type ListJobsRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 2;
	 */
	pagination?: PaginationArgumentsJson;
};

/**
 * Describes the message compliance.v1.ListJobsRequest.
 * Use `create(ListJobsRequestSchema)` to create a new message.
 */
export const ListJobsRequestSchema: GenMessage<ListJobsRequest, { jsonType: ListJobsRequestJson }> = /*@__PURE__*/ messageDesc(file_compliance_v1_compliance, 6);

/**
 * @generated from message compliance.v1.ListJobsResponse
 */
export type ListJobsResponse = Message<"compliance.v1.ListJobsResponse"> & {
	/**
	 * @generated from field: repeated compliance.v1.Job jobs = 1;
	 */
	jobs: Job[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo | undefined;
};

/**
 * @generated from message compliance.v1.ListJobsResponse
 */
export type ListJobsResponseJson = {
	/**
	 * @generated from field: repeated compliance.v1.Job jobs = 1;
	 */
	jobs?: JobJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message compliance.v1.ListJobsResponse.
 * Use `create(ListJobsResponseSchema)` to create a new message.
 */
export const ListJobsResponseSchema: GenMessage<ListJobsResponse, { jsonType: ListJobsResponseJson }> = /*@__PURE__*/ messageDesc(file_compliance_v1_compliance, 7);

/**
 * @generated from message compliance.v1.ListPurgeStepsRequest
 */
export type ListPurgeStepsRequest = Message<"compliance.v1.ListPurgeStepsRequest"> & {
	/**
	 * @generated from field: string job_id = 1;
	 */
	jobId: string;

	/**
	 * @generated from field: compliance.v1.PurgeStepStatus status = 2;
	 */
	status: PurgeStepStatus;

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 3;
	 */
	pagination?: PaginationArguments | undefined;
};

/**
 * @generated from message compliance.v1.ListPurgeStepsRequest
 */
export type ListPurgeStepsRequestJson = {
	/**
	 * @generated from field: string job_id = 1;
	 */
	jobId?: string;

	/**
	 * @generated from field: compliance.v1.PurgeStepStatus status = 2;
	 */
	status?: PurgeStepStatusJson;

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 3;
	 */
	pagination?: PaginationArgumentsJson;
};

/**
 * Describes the message compliance.v1.ListPurgeStepsRequest.
 * Use `create(ListPurgeStepsRequestSchema)` to create a new message.
 */
export const ListPurgeStepsRequestSchema: GenMessage<ListPurgeStepsRequest, { jsonType: ListPurgeStepsRequestJson }> = /*@__PURE__*/ messageDesc(file_compliance_v1_compliance, 8);

/**
 * @generated from message compliance.v1.ListPurgeStepsResponse
 */
export type ListPurgeStepsResponse = Message<"compliance.v1.ListPurgeStepsResponse"> & {
	/**
	 * @generated from field: repeated compliance.v1.PurgeStep purge_steps = 1;
	 */
	purgeSteps: PurgeStep[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo | undefined;
};

/**
 * @generated from message compliance.v1.ListPurgeStepsResponse
 */
export type ListPurgeStepsResponseJson = {
	/**
	 * @generated from field: repeated compliance.v1.PurgeStep purge_steps = 1;
	 */
	purgeSteps?: PurgeStepJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message compliance.v1.ListPurgeStepsResponse.
 * Use `create(ListPurgeStepsResponseSchema)` to create a new message.
 */
export const ListPurgeStepsResponseSchema: GenMessage<ListPurgeStepsResponse, { jsonType: ListPurgeStepsResponseJson }> = /*@__PURE__*/ messageDesc(file_compliance_v1_compliance, 9);

/**
 * @generated from message compliance.v1.ListPurgesRequest
 */
export type ListPurgesRequest = Message<"compliance.v1.ListPurgesRequest"> & {
	/**
	 * @generated from field: string job_id = 1;
	 */
	jobId: string;

	/**
	 * @generated from field: compliance.v1.PurgeStepStatus status = 2;
	 */
	status: PurgeStepStatus;

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 3;
	 */
	pagination?: PaginationArguments | undefined;
};

/**
 * @generated from message compliance.v1.ListPurgesRequest
 */
export type ListPurgesRequestJson = {
	/**
	 * @generated from field: string job_id = 1;
	 */
	jobId?: string;

	/**
	 * @generated from field: compliance.v1.PurgeStepStatus status = 2;
	 */
	status?: PurgeStepStatusJson;

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 3;
	 */
	pagination?: PaginationArgumentsJson;
};

/**
 * Describes the message compliance.v1.ListPurgesRequest.
 * Use `create(ListPurgesRequestSchema)` to create a new message.
 */
export const ListPurgesRequestSchema: GenMessage<ListPurgesRequest, { jsonType: ListPurgesRequestJson }> = /*@__PURE__*/ messageDesc(file_compliance_v1_compliance, 10);

/**
 * @generated from message compliance.v1.ListPurgesResponse
 */
export type ListPurgesResponse = Message<"compliance.v1.ListPurgesResponse"> & {
	/**
	 * @generated from field: repeated compliance.v1.PurgeStep purge_steps = 1;
	 */
	purgeSteps: PurgeStep[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo | undefined;
};

/**
 * @generated from message compliance.v1.ListPurgesResponse
 */
export type ListPurgesResponseJson = {
	/**
	 * @generated from field: repeated compliance.v1.PurgeStep purge_steps = 1;
	 */
	purgeSteps?: PurgeStepJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message compliance.v1.ListPurgesResponse.
 * Use `create(ListPurgesResponseSchema)` to create a new message.
 */
export const ListPurgesResponseSchema: GenMessage<ListPurgesResponse, { jsonType: ListPurgesResponseJson }> = /*@__PURE__*/ messageDesc(file_compliance_v1_compliance, 11);

/**
 * @generated from enum compliance.v1.PurgeStepStatus
 */
export enum PurgeStepStatus {
	/**
	 * @generated from enum value: PURGE_STEP_STATUS_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: PURGE_STEP_STATUS_SUCCESS = 1;
	 */
	SUCCESS = 1,

	/**
	 * @generated from enum value: PURGE_STEP_STATUS_FAILURE = 2;
	 */
	FAILURE = 2,
}

/**
 * @generated from enum compliance.v1.PurgeStepStatus
 */
export type PurgeStepStatusJson = "PURGE_STEP_STATUS_UNSPECIFIED" | "PURGE_STEP_STATUS_SUCCESS" | "PURGE_STEP_STATUS_FAILURE";

/**
 * Describes the enum compliance.v1.PurgeStepStatus.
 */
export const PurgeStepStatusSchema: GenEnum<PurgeStepStatus, PurgeStepStatusJson> = /*@__PURE__*/ enumDesc(file_compliance_v1_compliance, 0);

/**
 * @generated from service compliance.v1.ComplianceService
 */
export const ComplianceService: GenService<{
	/**
	 * @generated from rpc compliance.v1.ComplianceService.PurgeData
	 */
	purgeData: {
		methodKind: "unary";
		input: typeof PurgeDataRequestSchema;
		output: typeof PurgeDataResponseSchema;
	};
	/**
	 * @generated from rpc compliance.v1.ComplianceService.BulkPurgeData
	 */
	bulkPurgeData: {
		methodKind: "unary";
		input: typeof BulkPurgeDataRequestSchema;
		output: typeof BulkPurgeDataResponseSchema;
	};
	/**
	 * @generated from rpc compliance.v1.ComplianceService.ListJobs
	 */
	listJobs: {
		methodKind: "unary";
		input: typeof ListJobsRequestSchema;
		output: typeof ListJobsResponseSchema;
	};
	/**
	 * @generated from rpc compliance.v1.ComplianceService.ListPurgeSteps
	 */
	listPurgeSteps: {
		methodKind: "unary";
		input: typeof ListPurgeStepsRequestSchema;
		output: typeof ListPurgeStepsResponseSchema;
	};
	/**
	 * @generated from rpc compliance.v1.ComplianceService.ListPurges
	 */
	listPurges: {
		methodKind: "unary";
		input: typeof ListPurgesRequestSchema;
		output: typeof ListPurgesResponseSchema;
	};
}> = /*@__PURE__*/ serviceDesc(file_compliance_v1_compliance, 0);
